import supabase from "../services/supabaseClient";
import { sleep } from "./asyncHelper";

/** worlds.world_json for user — null when no row yet (first-run / pre–Brain Dump). */
export async function fetchWorldForUser(userId, { retries = 2, retryDelayMs = 500 } = {}) {
  let lastError = null;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    const { data, error } = await supabase
      .from("worlds")
      .select("world_json")
      .eq("user_id", userId)
      .maybeSingle();

    if (!error) {
      return { worldJson: data?.world_json ?? null, error: null };
    }

    lastError = error;
    console.error(`fetchWorldForUser (attempt ${attempt + 1}/${retries + 1}):`, error);
    if (attempt < retries) {
      await sleep(retryDelayMs * (attempt + 1));
    }
  }

  return { worldJson: null, error: lastError };
}

/** user_profile row — null when quiz not completed yet. */
export async function fetchUserProfileForUser(userId) {
  const { data, error } = await supabase
    .from("user_profile")
    .select("*")
    .eq("user_id", userId)
    .maybeSingle();

  if (error) {
    console.error("fetchUserProfileForUser:", error);
    return { profile: null, error };
  }

  return { profile: data ?? null, error: null };
}
